/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_New_Error_CreateInputs */

const vi_sl_new_error_create = /** @type {(inputs: Sl_New_Error_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lỗi tạo phiếu`)
};

/**

* @param {Sl_New_Error_CreateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_new_error_create = /** @type {((inputs?: Sl_New_Error_CreateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_New_Error_CreateInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_new_error_create(inputs)
});